import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NavService } from '../../../services/nav.service';
import { FooterComponent } from '../../footer/footer.component';
import { HeaderComponent } from '../../header/header.component';
import { SidebarComponent } from '../../sidebar/sidebar.component';
import { SidebarMenuSkeletonComponent } from '../../ui/skeleton/sidebar-menu-skeleton/sidebar-menu-skeleton.component';
import { isPlatformBrowser } from '@angular/common';
import { GetRoleAuthorizeDetails } from '../../../store/action/role-management.action';
import { Store } from '@ngxs/store';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

@Component({
  selector: 'app-content',
  standalone: true,
  imports: [RouterModule, HeaderComponent, FooterComponent,
            SidebarMenuSkeletonComponent, SidebarComponent, RouterModule,
            LoadingBarRouterModule
  ],
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss'
})
export class ContentComponent {

  public isBrowser: boolean;

  constructor(
    private store: Store,
    public navServices: NavService, 
    private router: Router, 
    @Inject(PLATFORM_ID) private platformId: Object) {
    this.store.dispatch(new GetRoleAuthorizeDetails()).subscribe({
      next:(res)=>{
        if (res?.roleManagement?.data?.length > 0) {
          this.isBrowser = isPlatformBrowser(this.platformId);
        }
      }
    })
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if(event.url === '/order/create'){
          this.navServices.collapseSidebar = true;
        }
      }
    })
  }

}
